var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderGreenXl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.499 45.3335H102.499V35.3335C102.501 34.3482 102.308 33.3724 101.931 32.4618C101.555 31.5513 101.002 30.724 100.306 30.0273C99.609 29.3306 98.7817 28.7782 97.8712 28.4017C96.9606 28.0253 95.9848 27.8322 94.9995 27.8335H56.8745C55.7582 27.8337 54.656 27.5847 53.6482 27.1046C52.6405 26.6245 51.7526 25.9255 51.0495 25.0585L46.1495 19.0335C45.2154 17.8778 44.0347 16.9457 42.6937 16.3054C41.3527 15.6652 39.8855 15.3331 38.3995 15.3335H9.99948C9.01419 15.3322 8.03833 15.5253 7.1278 15.9017C6.21726 16.2782 5.38994 16.8306 4.69324 17.5273C3.99654 18.224 3.44414 19.0513 3.0677 19.9618C2.69126 20.8724 2.49816 21.8482 2.49948 22.8335V96.7585C2.49431 97.8846 2.71512 99.0002 3.14883 100.039C3.58254 101.079 4.22035 102.02 5.02448 102.809C5.81277 103.613 6.75438 104.25 7.79358 104.684C8.83277 105.118 9.94842 105.339 11.0745 105.334H95.2245C97.082 105.333 98.8893 104.731 100.376 103.618C101.863 102.505 102.95 100.94 103.474 99.1585L117.299 51.7335C117.515 50.9884 117.555 50.2034 117.415 49.4403C117.276 48.6773 116.961 47.9571 116.495 47.3365C116.03 46.7159 115.427 46.212 114.733 45.8644C114.04 45.5168 113.275 45.3351 112.499 45.3335V45.3335Z",
    fill: "url(#paint0_linear_1_5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.496 45.3335H41.4307C39.5754 45.3337 37.7701 45.9357 36.2859 47.0491C34.8018 48.1625 33.7188 49.7273 33.1995 51.5085L19.2995 99.162C18.7802 100.942 17.6975 102.506 16.2138 103.619C14.7301 104.732 12.9256 105.333 11.071 105.334H95.2305C97.0862 105.334 98.8919 104.732 100.376 103.618C101.861 102.505 102.944 100.94 103.464 99.1585L117.296 51.7335C117.514 50.9883 117.555 50.2027 117.416 49.439C117.277 48.6753 116.962 47.9544 116.496 47.3334C116.031 46.7124 115.427 46.2084 114.732 45.8613C114.038 45.5142 113.272 45.3335 112.496 45.3335V45.3335Z",
    fill: "url(#paint1_linear_1_5)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5",
    x1: 14.6961,
    y1: 101.048,
    x2: 62.8522,
    y2: -3.06196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15B073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FF0B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_5",
    x1: 22.3585,
    y1: 102.476,
    x2: 47.6276,
    y2: 26.6399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21CA88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFFF7",
    stopOpacity: 0.4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderGreenXl);
export default __webpack_public_path__ + "static/media/folder-green-xl.d6d6f6b8.svg";
export { ForwardRef as ReactComponent };